import { Button } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const RelativeSearch = styled('div')(() => ({
  position: 'relative',
}));

export const SearchWrapper = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1),
  left: 0,
  right: 0,
  zIndex: 10,
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${alpha(theme.palette.text.primary, 0.12)}`,
  boxShadow: theme.shadows[3],
  maxHeight: 280,
  overflowY: 'auto',
}));

export const InviteUserRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  padding: theme.spacing(1, 1.5),
  cursor: 'pointer',
  transition: 'background-color 120ms ease-in-out',
  '&:hover': {
    backgroundColor: alpha(theme.palette.text.primary, 0.04),
  },
}));

export const TitleName = styled('span')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.pxToRem(14),
  fontWeight: 500,
}));

export const RoleDisclaimer = styled('span')(({ theme }) => ({
  display: 'block',
  marginTop: theme.spacing(1),
  fontSize: theme.typography.pxToRem(12),
  color: theme.palette.text.secondary,
}));

export const InviteButton = styled(Button)({
  height: '100%',
});
